/** BWOF workflow labels & colors (mirrors backend constants/bwofWorkflow.js) */

export const PHASE_LABELS = {
  WATCH: 'Watch ?? due dates',
  WORK: 'Work ?? inspections',
  CLOSE: 'Close ?? council',
};

export const WATCH_LABELS = {
  due_ok: 'On track',
  due_soon: 'Due soon',
  due_urgent: 'Due urgent',
  overdue: 'Overdue',
};

export const WORK_LABELS = {
  not_started: 'Not started',
  in_progress: 'In progress',
  repair_hold: 'Repair hold',
  all_jobs_done: 'All inspections done',
};

export const CLOSE_LABELS = {
  pack_prep: 'Pack & pay',
  paid: 'Paid',
  lodged: 'Lodged',
  under_review: 'Council review',
  approved: 'BWOF current',
};

export const JOB_STAGE_LABELS = {
  no_job: 'No inspection',
  unassigned: 'Unassigned',
  assigning: 'Assigning',
  accepted: 'Accepted',
  booked: 'Booked',
  on_site: '',
  failed: 'Failed',
  repair_ordered: 'Repair ordered',
  repairing: 'Repairing',
  reinspection: 'Re-inspection',
  job_done: 'Done',
};

export function phaseBadgeClass(phase) {
  switch (phase) {
    case 'WATCH':
      return 'bg-slate-100 text-slate-800 border-slate-200';
    case 'WORK':
      return 'bg-blue-100 text-blue-900 border-blue-200';
    case 'CLOSE':
      return 'bg-emerald-100 text-emerald-900 border-emerald-200';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}

export function jobStageBadgeClass(stage) {
  if (['failed', 'repair_ordered'].includes(stage)) return 'bg-red-100 text-red-800';
  if (['repairing', 'reinspection'].includes(stage)) return 'bg-amber-100 text-amber-900';
  if (stage === 'job_done') return 'bg-gray-100 text-gray-700';
  if (['booked', 'accepted', 'on_site'].includes(stage)) return 'bg-blue-100 text-blue-800';
  if (stage === 'assigning') return 'bg-yellow-100 text-yellow-900';
  return 'bg-red-50 text-red-800';
}

export function watchStepBadgeClass(step) {
  if (step === 'overdue') return 'bg-red-100 text-red-900';
  if (step === 'due_urgent') return 'bg-orange-100 text-orange-900';
  if (step === 'due_soon') return 'bg-yellow-100 text-yellow-900';
  return 'bg-green-50 text-green-800';
}
